import { fetchWrapperPlatform } from "./fetch";

export const sendMessage = async (streamId, messageData) =>
  await fetchWrapperPlatform({
    url: `chats/${streamId}/messages`,
    method: `POST`,
    body: JSON.stringify(messageData),
    addBearer: true,
  });

export const sendReaction = async (streamId, reactionData) =>
  await fetchWrapperPlatform({
    url: `chats/${streamId}/reactions`,
    method: `POST`,
    body: JSON.stringify(reactionData),
    addBearer: true,
  });

export const deleteMessage = async (streamId, messageId) =>
  await fetchWrapperPlatform({
    url: `chats/${streamId}/messages/${messageId}`,
    method: `DELETE`,
    addBearer: true,
  });

export const blockUser = async (streamId, blockData) =>
  await fetchWrapperPlatform({
    url: `chats/${streamId}/block`,
    method: `POST`,
    body: JSON.stringify(blockData),
    addBearer: true,
  });

export const unblockUser = async (streamId, unblockData) =>
  await fetchWrapperPlatform({
    url: `chats/${streamId}/unblock`,
    method: `POST`,
    body: JSON.stringify(unblockData),
    addBearer: true,
  });

export const pinMessage = async (streamId, messageData) =>
  await fetchWrapperPlatform({
    url: `chats/${streamId}/pin`,
    method: `POST`,
    body: JSON.stringify(messageData),
    addBearer: true,
  });

export const unpinMessage = async (streamId) =>
  await fetchWrapperPlatform({
    url: `chats/${streamId}/pin`,
    method: `DELETE`,
    addBearer: true,
  });
